﻿import $ from 'jquery';
import { debounce } from './utils';
import WorkplaceService from "./WorkplaceService";

export default class EmploymentCitySelector extends HTMLInputElement {

    constructor() {
        super();

        this._cities = null;
    }

    connectedCallback() {

        $(this).typeahead({
            items: 'all',
            showHintOnFocus: true,
            minLength: 2,
            fitToElement: true,
            source: debounce(this.getCities, 200, this)
        });

        this.initA11y();

    }

    initA11y() {
        this.setAttribute("role", "combobox");
        this.setAttribute("aria-haspopup", "listbox");
        this.setAttribute("aria-autocomplete", "list");
        this.setAttribute("aria-expanded", "false");

        $(this).closest(".form-group").on("show.bs.typeahead", ".dropdown-menu", e => {
            this.setAttribute("aria-expanded", "true");
        });

        $(this).closest(".form-group").on("hide.bs.typeahead", ".dropdown-menu", e => {
            this.setAttribute("aria-expanded", "false");
        });
    }

    disconnectedCallback() {

        $(this).typeahead("destroy");
        //this.removeEventListener("input", this.getWorkplaces);

    }

    getCities(query, process) {

        if (this._cities !== null) {
            return process(this._cities);
        }

        const workplaceService = new WorkplaceService();

        return workplaceService.getCities().done(data => {
            this._cities = data;
            return process(data);
        });
    }

}

customElements.define("employment-city", EmploymentCitySelector, { extends: "input" });